import CustomApplicationWidget from './component'

export default CustomApplicationWidget
